<div
  class="form-field"
  [ngClass]="{
    'entry-field--error': isError$ | async,
    'entry-field--outline': outline,
    'form-field--combo': isComboTheme
  }"
>
  <div #inputRef>
    <ng-content select="input"></ng-content>
  </div>
  <div #selectRef>
    <ng-content select="ng-select"></ng-content>
  </div>

  <label
    [ngClass]="{
      'form-field__label': isNormalTheme(),

      'form-field-cp-box__label-select': isAltTheme && hasSelectInFormField(),
      'form-field-cp-box__label-input': isAltTheme && hasInputInFormField(),
      'form-field__label__focus': shouldLabelFloat()
    }"
  >
    <ng-content select="cp-label"></ng-content>
  </label>

  <div class="form-field__suffix">
    <ng-content select="cp-suffix"></ng-content>
  </div>
  <ng-content select="cp-error" *ngIf="isError$ | async"></ng-content>
  <ng-content select="cp-footer"></ng-content>
  <ng-content select="cp-icon"></ng-content>
</div>
